import {IStateMyPage} from './reducer';
import {createAction, createBasicActions} from '../../../common/util/redux';
import {MyPagePurchaseEpisode} from '../type';

export enum ActionType {
  SetValue = 'myPage.SetValue',
  SetPropertyValues = 'myPage.SetPropertyValues',
  AddMyPageEpisodes = 'myPage.AddMyPageEpisodes',
}

export const actions = {
  ...createBasicActions<IStateMyPage>({
    setValueActionType: ActionType.SetValue,
    setPropertyValuesActionType: ActionType.SetPropertyValues,
  }),
  addMyPageEpisodes: (data: MyPagePurchaseEpisode, isFirst?: boolean) =>
    createAction(ActionType.AddMyPageEpisodes, {
      isFirst,
      data,
    }),
};
